import Vue from 'vue';
import {Component, Prop as prop} from 'vue-property-decorator';
import {FileMapping, MealFile, MealCategory} from '@/types/data';
import {Constants as constants} from '../../../../config/constants';
import {Helpers} from '@/app/common/helpers';

@Component
export default class FileListComponent extends Vue {
    public fileInput = null as HTMLInputElement | null;
    public fileToAdd = null as MealFile | null;
    public fileName = '';
    public fileCategory = '' as MealCategory;

    @prop()
    private files: FileMapping[] | undefined;

    public deleteFile(index: number) {
        this.$parent.$emit(constants.fileEvents.remove, index);
    }

    public submitFile() {
        this.fileToAdd!.category = this.fileCategory;
        this.$parent.$emit(constants.fileEvents.add, {
            data: Helpers.doFullCopy(this.fileToAdd),
            fileName: this.fileName
        });

        this.fileInput!.value = '';
        this.fileToAdd = null;
        this.fileName = '';
        this.fileCategory = '' as MealCategory;
    }

    public fileChanged(event: Event) {
        this.fileInput = event.target as HTMLInputElement;

        if ((event.target as HTMLInputElement).files!.length) {
            Helpers.parseJSONFile((event.target as HTMLInputElement).files![0]).then((file: MealFile | any) => {
                if (Helpers.verifyJSONData(file)) {
                    this.fileToAdd = file;
                    this.fileName = (event.target as HTMLInputElement).files![0].name;
                } else {
                    (event.target as HTMLInputElement).value = '';
                    this.fileToAdd = null;
                }
            });
        }
    }

    public get isAddAvailable() {
        return this.files!.length < constants.maxFiles;
    }
}
